import { ComponentProps, useState } from "react";
import { Divider, IconButton, Tooltip, Typography } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import ReportSettingsModal from "../ReportSettingsModal";
import StrategyTaxStateSetting from "../StrategyTaxStateSetting";
import StrategyFederalTaxSetting from "../StrategyFederalTaxSetting";
import SummaryFormulaSettings from "./SummaryFormulaSettings";

/**
 * The Strategy Report's one Settings view, opened from the gear in the
 * filters' bottom-right corner. It gathers every setting the cards used to carry
 * on their own gears -- the summary's formulas and the Keep card's tax rates
 * -- so each can be set before the first Calculate, while the cards below are
 * still hidden (task 5001). All of them are sent with Calculate.
 */
const StrategyReportSettings = (
  formulaProps: ComponentProps<typeof SummaryFormulaSettings>,
) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Tooltip title="Report settings">
        <IconButton
          aria-label="Report settings"
          size="small"
          onClick={() => setOpen(true)}
        >
          <SettingsIcon />
        </IconButton>
      </Tooltip>
      <ReportSettingsModal
        open={open}
        onClose={() => setOpen(false)}
        title="Report Settings"
      >
        <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "bold" }}>
          Summary
        </Typography>
        <SummaryFormulaSettings {...formulaProps} />
        <Divider sx={{ my: 2 }} />
        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          Tax Savings
        </Typography>
        <StrategyTaxStateSetting />
        <StrategyFederalTaxSetting />
      </ReportSettingsModal>
    </>
  );
};

export default StrategyReportSettings;
